import React from 'react';
import { Avatar } from '@material-ui/core';

const ClientIcon: React.FC<{ className?: string; userName: string }> = ({ userName }) => {
    const letters = userName
        .split(' ')
        .filter((x: string) => x.length)
        .map((x: string) => x[0]);

    return (
        <Avatar>
            {letters[0] || ''}
            {letters[1] || ''}
        </Avatar>
    );
};

export default ClientIcon;
